/* global WebView, ViewController */
var initLogin = require("../../util/initLogin") ;

var LoginPortalController = ViewController.create({
    directory : "views/portal",
    name: "loginPortal",
    container: "main",
    noRouting:true
}) ;

LoginPortalController.prototype.prepareDataOnEnter = function(data, callback){
    //normal login
    callback(null, {
        lang: WebView.i18n.getLang() 
    });
};

LoginPortalController.prototype.onLang = function(){
    this.view.updateData(); 
    WebView.i18n.setLang(this.data.lang) ;
} ;

LoginPortalController.prototype.focusLogin = function(){
    this.view.focusLogin() ;
};

LoginPortalController.prototype.onConnect = function(){
    this.view.updateData(); 
    this.data.error = "" ;
    var errors = [] ;
    if(!this.data.connectLogin){
        errors.push(this.view.tr("login.pleaseInputLogin")) ;
    }
    if(!this.data.connectPassword){
        errors.push(this.view.tr("login.pleaseInputPassword")) ;
    }
    if(errors.length>0){
        this.data.error = errors.join("<br/>") ;
        return this.view.reload() ;
    }
    this.view.longTask(function(done){
        this._doConnect(this.data.connectLogin, this.data.connectPassword, done) ;
    }.bind(this)) ;
} ;

LoginPortalController.prototype._doConnect = function(connectLogin, connectPassword, callback){
    this.api.auth.user(connectLogin, connectPassword, "portal", function(err, user){
        if(err){
            if (["invalidPassword","invalidUser","portalIsNotActivated","userPortalIsDeactivated", "technicalError","unknownUsername","technicalError","maxAttemptsReached"].includes(err)) {
                this.data.error = this.view.tr(`login.${err}`) ;
            } else {
                this.data.error = this.view.tr("login.cantLogin") ;
            }
            this.view.reload() ;
            return callback() ;
        }
        //login OK
        initLogin(user, function(err){
            if(err){ return callback(err) ; }
            this.view.reload() ; 
            
            this.resumeNavigation("/portal") ;
            return callback() ;
        }.bind(this)) ;

    }.bind(this)) ;
} ;

LoginPortalController.prototype.onForgotPass = function(){
    this.appController.context.controllers.forgotPasswordPortalController.enter() ;
} ;

module.exports = new LoginPortalController() ;
